import React from "react";
import Message from "./Message";
import useUpdateShowMessage from "./useUpdateShowMessage";

/**
 * @typedef {import("./minMaxErrorMessageTypes").MessageProps} MessageProps
 * @typedef {import("./minMaxErrorMessageTypes").UseUpdateShowMessageProps} UseUpdateShowMessageProps
 */

/**
 *
 * @param {object} props
 * @param {MessageProps} props.messageProps
 * @param {UseUpdateShowMessageProps} props.useUpdateShowMessageProps
 * @returns {React.ReactElement}
 */
const MinMaxErrorMessage = ({ messageProps, useUpdateShowMessageProps }) => {
    useUpdateShowMessage(useUpdateShowMessageProps);

    return <Message {...messageProps} />;
};

export default MinMaxErrorMessage;
